import React, { useState } from 'react';
import '../../../Home/Parceiros/style.css';
import ModalMessage from '../../Modal/ModalMessage';
import ModalConfirm from '../../Modal/ModalConfirm';
import './SectionParceiros.css';

const tabs = [
  { key: 'parceiros-institucionais', label: 'Parceiros Institucionais' },
  { key: 'parceiros-em-projetos', label: 'Parcerias em Projetos' },
  { key: 'patrocinio', label: 'Patrocínios' },
  { key: 'apoiadores', label: 'Apoiadores' },
];

export default function SectionParceiros({ isEditing, parceiros, setParceiros }) {
  const [activeTab, setActiveTab] = useState(tabs[0].key);
  const [modalMessage, setModalMessage] = useState('');
  const [isModalMessageOpen, setIsModalMessageOpen] = useState(false);
  const [isModalConfirmOpen, setIsModalConfirmOpen] = useState(false);
  const [parceiroParaRemover, setParceiroParaRemover] = useState(null);

  const parceirosAtuais = parceiros.filter((parc) => parc.category === activeTab);

  // Instancia e carrega um novo parceiro na categoria da aba ativa
  const handleAddParceiro = () => {
    setParceiros([
      ...parceiros,
      {
        id: Date.now(),
        category: activeTab,
        name: '',
        logoUrl: 'https://via.placeholder.com/200x100?text=Nova+Logo',
        redirectUrl: '',
        file: null,
      },
    ]);
  };

  const handleChange = (id, campo, valor) => {
    setParceiros(
      parceiros.map((parc) =>
        parc.id === id || parc._id === id ? { ...parc, [campo]: valor } : parc
      )
    );
  };

  const handleImageUpload = (id, event) => {
    const file = event.target.files[0];
    if (!file) return;

    if (!['image/jpeg', 'image/png'].includes(file.type)) {
      setModalMessage('Formato inválido. A imagem deve ser JPG ou PNG.');
      setIsModalMessageOpen(true);
      return;
    }

    if (file.size > 15 * 1024 * 1024) {
      setModalMessage('A imagem é muito grande. O tamanho máximo permitido é 15MB.');
      setIsModalMessageOpen(true);
      return;
    }

    setParceiros(
      parceiros.map((parc) =>
        parc.id === id || parc._id === id
          ? { ...parc, logoUrl: URL.createObjectURL(file), file: file }
          : parc
      )
    );
  };

  const handleRemoveParceiro = (idToRemove) => {
    setParceiroParaRemover(idToRemove);
    setIsModalConfirmOpen(true);
  };

  const handleConfirmRemoveParceiro = () => {
    setParceiros(
      parceiros.filter((parc) => parc.id !== parceiroParaRemover && parc._id !== parceiroParaRemover)
    );
    setIsModalConfirmOpen(false);
    setParceiroParaRemover(null);
  };

  return (
    <section className="parceiros parceiros--admin">
      <div className="parceiros__cabecalho">
        <h3 className="parceiros__titulo-secao">Parceiros</h3>
        <nav className="parceiros__tabs admin-parceiros-tabs">
          {tabs.map((tab) => (
            <button
              key={tab.key}
              type="button"
              className={`parceiros__tab ${activeTab === tab.key ? 'parceiros__tab--ativo' : ''}`}
              onClick={() => setActiveTab(tab.key)}
            >
              {tab.label}
            </button>
          ))}
        </nav>
      </div>

      <div className="parceiros-admin-content">
        {parceirosAtuais.length === 0 ? (
          <p className="parceiros__vazio" style={{ textAlign: 'center', width: '100%' }}>
            Não há parceiros cadastrados nesta categoria.
          </p>
        ) : (
          <div className="parceiros__grid parceiros__grid--admin">
            {parceirosAtuais.map((parc, index) => {
              const id = parc.id || parc._id || index;

              return (
                <div key={id} className="parceiro-admin-card-wrapper">
                  <div className="parceiros__logo parceiros__logo--admin-box">
                    {parc.logoUrl ? (
                      <img key={parc.logoUrl} src={parc.logoUrl} alt={parc.name || 'Logo Parceiro'} />
                    ) : (
                      <span>{parc.name || 'Sem Logo'}</span>
                    )}

                    {isEditing && (
                      <label className="parceiro-upload-overlay">
                        <input
                          type="file"
                          accept=".jpg, .jpeg, .png"
                          onChange={(e) => handleImageUpload(id, e)}
                          hidden
                        />
                        <svg viewBox="0 0 24 24" width="20" height="20" fill="#fff">
                          <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-5-7l-3 3.72L9 13l-3 4h14l-4-5z" />
                        </svg>
                        <span>Alterar Logo</span>
                      </label>
                    )}
                  </div>

                  {isEditing && (
                    <div className="parceiro-edit-fields">
                      <input
                        type="text"
                        className="admin-input-parceiro"
                        placeholder="Nome do Parceiro"
                        value={parc.name || ''}
                        onChange={(e) => handleChange(id, 'name', e.target.value)}
                      />
                      <input
                        type="text"
                        className="admin-input-parceiro"
                        placeholder="Link (Opcional)"
                        value={parc.redirectUrl || ''}
                        onChange={(e) => handleChange(id, 'redirectUrl', e.target.value)}
                      />
                      <button
                        type="button"
                        className="btn-remover-parceiro"
                        onClick={() => handleRemoveParceiro(id)}
                      >
                        Excluir Parceiro
                      </button>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}

        {isEditing && (
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: '2.5rem' }}>
            <button type="button" className="btn-add-novo" onClick={handleAddParceiro}>
              <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
                <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
              </svg>
              Adicionar Parceiro em "{tabs.find((t) => t.key === activeTab)?.label}"
            </button>
          </div>
        )}
      </div>

      <ModalMessage
        isOpen={isModalMessageOpen}
        onClose={() => setIsModalMessageOpen(false)}
        message={modalMessage}
      />

      <ModalConfirm
        isOpen={isModalConfirmOpen}
        onClose={() => setIsModalConfirmOpen(false)}
        onConfirm={handleConfirmRemoveParceiro}
        message="Confirmar a exclusão deste parceiro?"
      />
    </section>
  );
}
